module.exports = __webpack_public_path__ + "assets/sprvsr.png?b4dc2662a9fb7b97099c980ac68fc05a";